<template>
  <div v-if="headerIsDropdown" class="dropdown">
    <button
      type="button"
      :class="classes"
      class="dropdown-toggle btn-table-header"
      data-toggle="dropdown"
      :aria-sort="aria"
      aria-haspopup="true"
      aria-expanded="false"
      style="text-transform: uppercase"
    >
      <slot></slot>
    </button>
    <ul aria-expanded="false" class="dropdown-menu" x-placement="bottom-start">
      <li v-for="(sortOption, index) in dropdownSortOptions" :key="index">
        <button type="button" @click.prevent="$emit('click', sortOption)" :class="sortDropdownItemClasses(sortOption)" aria-selected="false">
          <span class="sr-only">{{ sortOption.direction === "asc" ? "Ascending" : "Descending" }}</span>
          <span aria-hidden="true" :class="sortOption.direction === 'asc' ? 'icon up' : 'icon down'"></span>
          {{sortOption.displayName}}
        </button>
      </li>
    </ul>
  </div>

  <button v-else
          type="button"
          @click.prevent="$emit('click', value)"
          :class="classes"
          class="btn-table-header"
          :aria-sort="aria">
    <slot></slot>
  </button>
</template>

<script lang="ts">
  import Vue from "vue";
  import {IPagination} from "~/models/pagination";

  export default Vue.extend({
    props: {
      tag: {
        type: String,
        default: 'a'
      },
      sort: {
        type: [
          String as () => IPagination["sort"],
          Number as () => number
        ]
      },
      direction: {
        type: String as () => IPagination["direction"]
      },
      value: {
        type: [
          String as () => IPagination["sort"],
          Number as () => number
        ]
      },
      headerType: {
        type: String,
        default: "toggle"
      },
      dropdownSortOptions: {
        type: Array,
      }
    },
    data: function() {
      return {};
    },
    computed: {
      aria(): string {
        switch (this.direction) {
          case "asc":
            return "ascending";
          case "desc":
            return "descending";
          default:
            return "default"
        }
      },
      classes(): object {
        return {
          up: this.sort === this.value && this.direction === 'asc',
          down: this.sort === this.value && this.direction === 'desc'
        }
      },
      headerIsDropdown(): boolean {
        return this.headerType === "dropdown"
      },
      href(): string {
        if (this.tag === 'a') {
          return `#${this.value}`;
        }
      },
    },
    methods: {
      sortDropdownItemClasses(sortOption): { 'dropdown-item': boolean, 'active': boolean } {
        return {
          'dropdown-item': true,
          'active': (this.sort === sortOption.id && this.direction === sortOption.direction),
        };
      },
    }
  });
</script>